export const environment = {
  production: true,
  pathBackend: '/api/v1',
  aiServiceUrl: 'https://ai-service.gainkodex.com',

  debug: false,
}
